if (!customElements.get('combined-bundle')) {
  class CombinedBundle extends HTMLElement {
    constructor() {
      super();
      
      this.mainID = new Date().getTime();
      this.set = [];
      this.cartDrawer = document.querySelector('cart-drawer');

      // Bind option select events
      this.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
        variant.addEventListener('click', this.onBundleVariantSelect.bind(this));
      });

      // Bind add to cart
      let testMe = document.querySelector('[data-test-me]');
      testMe.addEventListener('click', this.addBundle.bind(this));

      if (document.querySelector('[data-test-me-two]')) {
        document.querySelector('[data-test-me-two]').addEventListener('click', (event) => {
          testMe.click();
        });
      }

      // preselect variants
      if (location.search.indexOf('colors=') > -1) {
        let arr = location.search.split('colors=');
        let unformatted = arr[1].split('?');
        let preformatted = unformatted[0].split('&')
        let formatted = preformatted[0];
        let idArr = [];
        if (formatted.indexOf('%2C') > -1) {
          idArr = formatted.split('%2C');
        } else {
          idArr = formatted.split(',');
        }
        let productArr = this.querySelectorAll('[data-total-bundle]');
        idArr.forEach((id, index) => {
          if (productArr[index]) {
            if (productArr[index].querySelector('[data-bundle-variant-id="' + id + '"]')) {
              productArr[index].querySelector('[data-bundle-variant-id="' + id + '"]').click();
            }
          }
        });
      }
    }

    /**
     * onBundleVariantSelect
     * @description Toggles variant switch for bundles
     */
    onBundleVariantSelect(event) {
      let target = event.target;
      if (typeof target.src === 'undefined') {
        if (event.target.querySelector('img')) {
          target = event.target.querySelector('img');
        } else {
          target = event.target.closest('[data-bundle-variant]').querySelector('img');
        }
      }

      let group = target.closest('[data-bundle-variant-group]');
      group.querySelector('.border-black').classList.add('border-black-50');
      group.querySelector('.border-black').classList.remove('border-black');
      target.closest('[data-bundle-variant]').classList.remove('border-black-50');
      target.closest('[data-bundle-variant]').classList.add('border-black');
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').src = target.src;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').srcset = target.srcset;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] span').innerHTML = target.alt;
    }

    addBundle(event) {
      this.mainID = new Date().getTime();
      let itemArr = '';
      if (event.target.closest('combined-bundle')) {
        itemArr = event.target.closest('combined-bundle').querySelectorAll('[data-bundle-variant].border-black');
      } else {
        itemArr = document.querySelector('combined-bundle').querySelectorAll('[data-bundle-variant].border-black');
      }
      itemArr.forEach((item) => {
        let id = item.dataset.bundleVariantId;
        this.set.push(id);
      });
      this.addSet(event);
    }

    addSet(event) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const sectionsToFetch  = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
  
      let items = [];
      let object = {};

      let image = document.querySelector('[data-combined-bundle-image]').dataset.combinedBundleImage;
      let name = document.querySelector('[data-combined-bundle-name]').dataset.combinedBundleName;
      let elementData = document.querySelector('[data-combined-bundle-variant-id]').dataset;
      let theDiscount = document.querySelector('[data-combined-bundle-discount-new]').dataset.combinedBundleDiscountNew;

      let variantID = elementData.combinedBundleVariantId;
      let discount = elementData.combinedBundleDiscount;
      let quantity = document.querySelector('product-info .quantity__input').value;
      if (event.target.closest('product-info')) {
        if (event.target.closest('product-info').querySelector('.quantity__input')) {
          quantity = event.target.closest('product-info').querySelector('.quantity__input').value;
        }
      }
      let newTag = '';
      let newTagTag = '';
      let newTagFt = ''
      if (this.querySelector('input[name="properties[_new_tagging]"]')) {
        newTag = this.querySelector('input[name="properties[_new_tagging]"]').value;
      }
      if (this.querySelector('input[name="properties[_new_tag_tag]"]')) {
        newTagTag = this.querySelector('input[name="properties[_new_tag_tag]"]').value;
      }
      if (this.querySelector('input[name="properties[_new_tag_ft]"]')) {
        newTagFt = this.querySelector('input[name="properties[_new_tag_ft]"]').value;
      }
      let parser = false;
      if (this.querySelector('[data-promo-offer]')) {
        parser = true;
      }

      let offerData = this.querySelector('[data-promo-offer-hidden]');
      let hasOfferData = true;
      if (offerData != null) {
        hasOfferData = false;
        if (offerData.classList.contains('hidden')) {
          hasOfferData = true;
        }
      }


      if (hasOfferData) {
      } else {
        let jsonData = JSON.parse(this.querySelector('[data-promo-offer-data]').dataset.promoOfferData);
        let giftSeperate = jsonData.giftSeperate;
        object = {};
        let combi = jsonData.giftGuard + ':1';
        let giftDiscount = {
          "discount":"true",
          "amount": 100,
          "type":"percent",
          "label":"PROMO DISCOUNT",
          "combination": combi,
          "cart_totals": 0
        };
        if (giftSeperate) {
          object = {
            quantity: 1,
            id: parseInt(jsonData.giftVariant_id),
            properties: {
              "_discount": JSON.stringify(giftDiscount),
              "_new_tagging": newTag,
              "_new_tag_tag": newTagTag,
              "_new_tag_ft": newTagFt,
              "_free_product_notice": true,
              "_funnel": 'PDP',
              "_funnel_location": 'PROMO ATC',
              "_funnel_type": 'automatic'
            }
          }
        } else {
          image = jsonData.bundleImage;
          name = jsonData.bundleName;
          variantID = jsonData.bundleId;
          object = {
            quantity: 1,
            id: parseInt(jsonData.giftVariant_id),
            properties: {
              "product_bundle": 'Bundle-' + this.mainID,
              "_product_bundle_discount": discount,
              "_product_bundle_image": image,
              "_product_bundle_name": name,
              "_product_bundle_variant_id": variantID,
              "_discount": theDiscount,
              "_new_tagging": newTag,
              "_new_tag_tag": newTagTag,
              "_new_tag_ft": newTagFt,
              "_parser": parser,
              "_funnel": 'PDP',
              "_funnel_location": 'PROMO ATC',
              "_funnel_type": 'manual'
            }
          }
        }
        items.push(object);
      }

      if (location.href.indexOf('cd_parent=') > -1) {
        let parent = location.href.split('cd_parent=')[1].split('&')[0];
        this.set.forEach((set) => {
          object = {};
          object = {
            quantity: parseInt(quantity),
            id: parseInt(set),
            properties: {
              "product_bundle": 'Bundle-' + this.mainID,
              "_product_bundle_discount": discount,
              "_product_bundle_image": image,
              "_product_bundle_name": name,
              "_product_bundle_variant_id": variantID,
              "_discount": theDiscount,
              "_new_tagging": newTag,
              "_new_tag_tag": newTagTag,
              "_new_tag_ft": newTagFt,
              "_parser": parser,
              "_funnel": 'PDP',
              "_funnel_location": 'MAIN ATC',
              "_funnel_type": 'manual',
              "_cdUpsellParent": parent
            }
          }
          items.push(object);
        });
      } else {
        
        this.set.forEach((set) => {
          object = {};
          object = {
            quantity: parseInt(quantity),
            id: parseInt(set),
            properties: {
              "product_bundle": 'Bundle-' + this.mainID,
              "_product_bundle_discount": discount,
              "_product_bundle_image": image,
              "_product_bundle_name": name,
              "_product_bundle_variant_id": variantID,
              "_discount": theDiscount,
              "_new_tagging": newTag,
              "_new_tag_tag": newTagTag,
              "_new_tag_ft": newTagFt,
              "_parser": parser,
              "_funnel": 'PDP',
              "_funnel_location": 'MAIN ATC',
              "_funnel_type": 'manual'
            }
          }
          items.push(object);
        });

      }

      console.log('items', items);

  
      let body = JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((parsedState) => {

          localStorage.removeItem('refused_gifts');
    
          if (this.cartDrawer) {
            this.renderContents(parsedState);
          }

          document.body.classList.remove('product-bundle-is-open');
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cartDrawer.open();
          this.set = [];
        });

    }

    renderContents(parsedState) {

      this.getSectionsToRender().forEach((section) => {
        if (section?.selector) {
          const selector = document.querySelector(section.selector);
          if (selector) {
            selector.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.id],
              section.selector
            );
          }
        }
      });

      this.handlePromos();

      if (window.activePromo) {
        window.excludeFreeGift = false;
        if (document.querySelector('[data-promo-progressbar]')) {
          document.querySelector('[data-promo-progressbar]').classList.remove('hidden');
        }
        if (document.querySelector('[data-multi-progressbar]')) {
          document.querySelector('[data-multi-progressbar]').classList.remove('hidden');
          document.querySelector('.progressbar__bar-multi').classList.remove('hidden');
        }
      }

      this.cartDrawer.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
        btn.addEventListener('click', this.close.bind(this))
      );

      applyDiscounts();
  
    }

    handlePromos() {
      if (document.querySelector('[data-product-drawer-promos]')) {
        let promos = document.querySelector('[data-product-drawer-promos]');
        if (promos.dataset && promos.dataset.productDrawerPromos) {
          let promoData = JSON.parse(promos.dataset.productDrawerPromos);
          let enable_promo = promoData.promo_enabled;
  
          if (enable_promo) {
            let promo_variant_id = promoData.promo_variant_id;
            let add_product = promoData.add_product;
  
            // add product
            if (add_product) {
  
              let properties = {};
              properties._promo_product = 'true';
              
              let body = JSON.stringify({
                id: promo_variant_id,
                quantity: 1,
                properties,
                sections: this.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              });
              
              fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => response.json())
                .then((parsedState) => {
                  this.renderContents(parsedState);
                })
                .catch((e) => {
                  console.error(e);
                })
            }
          }
        }
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '[data-cart-drawer]',
        },
        {
          id: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    close() {
      document.body.classList.remove('cart-drawer-is-open');
      document.body.removeEventListener('click', this.onBodyClick);
    }

  }

  window.CombinedBundle = CombinedBundle;
  customElements.define('combined-bundle', CombinedBundle);
}
